import React from "react";
import logoWhite from "../../../images/logo-white-horizontal.png";
import LandingFooterLinks from "../LandingFooterLinks/LandingFooterLinks";
import localeText from "../../../../locale";

const LandingFooter = () => {
  return (
    <footer className="landing full-width" style={{ backgroundColor: "#2A2560", color: "#FAFBFC" }}>
      <section className="py-6">
        <div className="grid m-0">
          <div className="col-12 lg:col-3 flex flex-column gap-3 mb-5 lg:mb-0">
            <div>
              <img src={logoWhite} alt="Extraconomy" style={{ width: "100%", maxWidth: "275px" }} />
            </div>
            <p className="text-sm m-0" style={{ color: "#DCEFE3" }}>
              {localeText("followUs")}
            </p>
            <div className="flex gap-2">
              <a
                href="https://www.facebook.com/people/Extraconomy/61566025845885/"
                target="_blank"
                rel="noreferrer"
                className="flex align-items-center justify-content-center border-circle"
                style={{ width: "34px", height: "34px", backgroundColor: "rgba(255,255,255,0.1)" }}
              >
                <i className="pi pi-facebook" style={{ fontSize: "1rem", color: "#fff" }}></i>
              </a>
              <a
                href="https://www.instagram.com/extraconomy_official/#"
                target="_blank"
                rel="noreferrer"
                className="flex align-items-center justify-content-center border-circle"
                style={{ width: "34px", height: "34px", backgroundColor: "rgba(255,255,255,0.1)" }}
              >
                <i className="pi pi-instagram" style={{ fontSize: "1rem", color: "#fff" }}></i>
              </a>
              <a
                href="https://www.tiktok.com/@extraconomy"
                target="_blank"
                rel="noreferrer"
                className="flex align-items-center justify-content-center border-circle"
                style={{ width: "34px", height: "34px", backgroundColor: "rgba(255,255,255,0.1)" }}
              >
                <i className="pi pi-tiktok" style={{ fontSize: "1rem", color: "#fff" }}></i>
              </a>
              <a
                href="https://www.linkedin.com/company/extraconomy/"
                target="_blank"
                rel="noreferrer"
                className="flex align-items-center justify-content-center border-circle"
                style={{ width: "34px", height: "34px", backgroundColor: "rgba(255,255,255,0.1)" }}
              >
                <i className="pi pi-linkedin" style={{ fontSize: "1rem", color: "#fff" }}></i>
              </a>
              <a
                href="https://x.com/extraconomy"
                target="_blank"
                rel="noreferrer"
                className="flex align-items-center justify-content-center border-circle"
                style={{ width: "34px", height: "34px", backgroundColor: "rgba(255,255,255,0.1)" }}
              >
                <i className="pi pi-twitter" style={{ fontSize: "1rem", color: "#fff" }}></i>
              </a>
            </div>
          </div>
          <div className="col-12 lg:col-9 grid m-0">
            <LandingFooterLinks />
            <div className="col-12 sm:col-6 lg:col flex flex-column gap-3">
              <div className="text-md font-bold" style={{ color: "#fff" }}>
                {localeText("lp2FooterAppHeading")}
              </div>
              <div className="flex flex-column gap-2">
                <a
                  href="https://apps.apple.com/us/app/extraconomy/id6446035801"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src={`${process.env.PUBLIC_URL}/assets/appstores/AppStore.svg`}
                    alt="App Store"
                    style={{ height: "40px" }}
                  />
                </a>
                <a
                  href="https://play.google.com/store/apps/details?id=com.app.extraconomy"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src={`${process.env.PUBLIC_URL}/assets/appstores/GooglePlay.svg`}
                    alt="Google Play"
                    style={{ height: "40px" }}
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </footer>
  );
};

export default LandingFooter;
